import useDesignTokens from '@assetron/web-common/themes/useDesignTokens';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';

const useSignUpLandingStyles = () => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const styles = useMemo(
    () => ({
      alertContainer: {
        position: 'absolute',
        top: theme.sizeGuide['3xl'],
        width: '360px',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.sizeGuide.md,
      },
      root: {
        flex: 1,
        maxWidth: '360px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: theme.sizeGuide['8xl'],
        margin: 'auto',
        gap: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          maxWidth: '100%',
          margin: theme.sizeGuide.none,
          paddingTop: theme.sizeGuide['4xl'],
          paddingLeft: theme.sizeGuide.xl,
          paddingRight: theme.sizeGuide.xl,
        },
      },
      buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.sizeGuide.xl,
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      signinButtonContainer: {
        marginTop: theme.sizeGuide['4xl'],
        gap: theme.sizeGuide.xs,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        color: tokens.colors.text.secondary,
      },
      signinText: {
        textTransform: 'none',
      },
      signupLandingPageStyle: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      },
      signupFormStyle: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '400px !important',
        gap: theme.sizeGuide.xl,
        [theme.breakpoints.down('sm')]: {
          paddingTop: theme.sizeGuide['4xl'],
          width: 'auto',
        },
      },
      createAccountButtonTextStyle: {
        color: tokens.colors.text.white,
        textTransform: 'none',
        paddingTop: theme.sizeGuide.md,
        paddingBottom: theme.sizeGuide.md,
      },
      termAndPolicyTextStyle: {
        textAlign: 'center',
        color: tokens.colors.text.secondary,
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      policyLink: {
        textDecoration: 'none !important',
        color: tokens.colors.text.primary,
        ':hover': {
          textDecoration: 'underline',
        },
      },
      createAccountButtonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.sizeGuide.xl,
      },
      socialIdProviderButtonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.sizeGuide.xl,
      },
      dividerTextStyle: {
        display: 'block',
        color: tokens.colors.text.secondary,
      },
      googleSignUpText: {
        textTransform: 'none',
        padding: theme.sizeGuide.xxs,
      },
    }),
    [theme, tokens],
  );

  return styles;
};

export default useSignUpLandingStyles;
